// Auto-generated icon list - do not edit manually
export const iconList = [
  'ab-test',
  'academic-cap',
  'adjustments-horizontal',
  'adjustments-vertical',
  'archive-box',
  'archive-box-arrow-down',
  'archive-box-x-mark',
  'arrow-down',
  'arrow-down-circle',
  'arrow-down-left',
  'arrow-down-on-square',
  'arrow-down-on-square-stack',
  'arrow-down-right',
  'arrow-down-tray',
  'arrow-left',
  'arrow-left-circle',
  'arrow-long-down',
  'arrow-long-left',
  'arrow-long-right',
  'arrow-long-up',
  'arrow-path',
  'arrow-path-rounded-square',
  'arrow-right',
  'arrow-right-circle',
  'arrow-right-end-on-rectangle',
  'arrow-right-start-on-rectangle',
  'arrow-top-right-on-square',
  'arrow-trending-down',
  'arrow-trending-up',
  'arrow-turn-down-left',
  'arrow-turn-down-right',
  'arrow-turn-left-down',
  'arrow-turn-left-up',
  'arrow-turn-right-down',
  'arrow-turn-right-up',
  'arrow-turn-up-left',
  'arrow-turn-up-right',
  'arrow-up',
  'arrow-up-circle',
  'arrow-up-left',
  'arrow-up-on-square-stack',
  'arrow-up-right',
  'arrow-up-tray',
  'arrow-uturn-down',
  'arrow-uturn-left',
  'arrow-uturn-right',
  'arrow-uturn-up',
  'arrows-pointing-in',
  'arrows-pointing-out',
  'arrows-right-left',
  'arrows-up-down',
  'at-symbol',
  'audience',
  'automation',
  'backspace',
  'backward',
  'banknotes',
  'bars-2',
  'bars-3',
  'bars-3-bottom-left',
  'bars-3-bottom-right',
  'bars-3-center-left',
  'bars-4',
  'bars-arrow-down',
  'bars-arrow-up',
  'battery-0',
  'battery-100',
  'battery-50',
  'beaker',
  'bell',
  'bell-alert',
  'bell-slash',
  'bell-snooze',
  'bold',
  'bolt',
  'bolt-filled',
  'bolt-slash',
  'bolt-slash-filled',
  'book-open',
  'book-open-filled',
  'bookmark',
  'bookmark-filled',
  'bookmark-slash',
  'bookmark-slash-filled',
  'bookmark-square',
  'bookmark-square-filled',
  'briefcase',
  'bug-ant',
  'building-library',
  'building-office',
  'building-office-2',
  'building-storefront',
  'cake',
  'calculator',
  'calendar',
  'calendar-date-range',
  'calendar-days',
  'calendar-multi',
  'camera',
  'campaign',
  'chart-bar',
  'chart-bar-square',
  'chart-pie',
  'chat-bubble-bottom-center',
  'chat-bubble-bottom-center-text',
  'chat-bubble-left',
  'chat-bubble-left-ellipsis',
  'chat-bubble-left-right',
  'chat-bubble-oval-left',
  'chat-bubble-oval-left-ellipsis',
  'check',
  'check-badge',
  'check-circle',
  'check-thick',
  'chevron-double-down',
  'chevron-double-left',
  'chevron-double-right',
  'chevron-double-up',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevron-up-down',
  'circle-stack',
  'clipboard',
  'clipboard-document',
  'clipboard-document-check',
  'clipboard-document-list',
  'clock',
  'cloud',
  'cloud-arrow-down',
  'cloud-arrow-up',
  'code-bracket',
  'code-bracket-square',
  'cog',
  'cog-6-tooth',
  'cog-8-tooth',
  'command-line',
  'computer-desktop',
  'cpu-chip',
  'credit-card',
  'cube',
  'cube-transparent',
  'currency-bangladeshi',
  'currency-dollar',
  'currency-euro',
  'currency-pound',
  'currency-rupee',
  'currency-yen',
  'cursor-arrow-rays',
  'cursor-arrow-ripple',
  'customfields',
  'device-phone-mobile',
  'device-tablet',
  'divide',
  'document',
  'document-arrow-down',
  'document-arrow-up',
  'document-chart-bar',
  'document-check',
  'document-currency-bangladeshi',
  'document-currency-dollar',
  'document-currency-euro',
  'document-currency-pound',
  'document-currency-rupee',
  'document-currency-yen',
  'document-duplicate',
  'document-list',
  'document-magnifying-glass',
  'document-minus',
  'document-plus',
  'document-text',
  'dollar-sign',
  'dollar-sign-circle',
  'download',
  'drag',
  'edit',
  'ellipsis-horizontal',
  'ellipsis-horizontal-circle',
  'ellipsis-vertical',
  'email',
  'email-fill',
  'empty-tags',
  'engagement',
  'envelope',
  'envelope-open',
  'equals',
  'event-multi',
  'event-pos',
  'event-select',
  'event-ticket',
  'exclamation-circle',
  'exclamation-triangle',
  'export',
  'eye',
  'eye-dropper',
  'eye-slash',
  'face-frown',
  'face-smile',
  'film',
  'filter',
  'finger-print',
  'fire',
  'flag',
  'folder',
  'folder-arrow-down',
  'folder-minus',
  'folder-open',
  'folder-plus',
  'forward',
  'funnel',
  'gif',
  'gift',
  'gift-top',
  'globe-alt',
  'globe-americas',
  'globe-asia-australia',
  'globe-europe-africa',
  'h1',
  'h2',
  'h3',
  'hand-raised',
  'hand-thumb-down',
  'hand-thumb-up',
  'hashtag',
  'heart',
  'home',
  'home-modern',
  'icon-ticket',
  'identification',
  'inbox',
  'inbox-arrow-down',
  'inbox-stack',
  'information-circle',
  'insight',
  'insights',
  'italic',
  'key',
  'language',
  'lifebuoy',
  'light-bulb',
  'link',
  'link-slash',
  'list-bullet',
  'lock-closed',
  'lock-open',
  'login',
  'logo',
  'logo-brand',
  'logo-white',
  'logout',
  'magnifying-glass',
  'magnifying-glass-circle',
  'magnifying-glass-minus',
  'magnifying-glass-plus',
  'map',
  'map-pin',
  'megaphone',
  'messaging',
  'microphone',
  'minus',
  'minus-circle',
  'moon',
  'musical-note',
  'navigation-automation',
  'navigation-close',
  'navigation-open',
  'newspaper',
  'no-symbol',
  'numbered-list',
  'paint-brush',
  'paper-airplane',
  'paper-clip',
  'paper-plane',
  'pause',
  'pause-circle',
  'pencil',
  'pencil-square',
  'people-group',
  'percent-badge',
  'person',
  'phone',
  'phone-arrow-down-left',
  'phone-arrow-up-right',
  'phone-x-mark',
  'photo',
  'pin',
  'pin-filled-svg',
  'play',
  'play-circle',
  'play-pause',
  'plus',
  'plus-circle',
  'power',
  'presentation-chart-bar',
  'presentation-chart-line',
  'printer',
  'puzzle-piece',
  'qr-code',
  'question-mark-circle',
  'queue-list',
  'radio',
  'receipt-percent',
  'receipt-refund',
  'rectangle-group',
  'rectangle-stack',
  'rocket-launch',
  'rss',
  'scale',
  'scissors',
  'send',
  'server',
  'server-stack',
  'share',
  'shield-check',
  'shield-exclamation',
  'shopping-bag',
  'shopping-cart',
  'signal',
  'signal-slash',
  'slash',
  'sms',
  'solid-check-circle',
  'sparkles',
  'speaker-wave',
  'speaker-x-mark',
  'spotify',
  'square-2-stack',
  'square-3-stack-3d',
  'squares-2x2',
  'squares-plus',
  'star',
  'star-filled',
  'stop',
  'stop-circle',
  'strikethrough',
  'sun',
  'swatch',
  'table-cells',
  'tag',
  'tag-flag',
  'target',
  'ticket',
  'ticket-1',
  'ticket-2',
  'ticketek',
  'trash',
  'trophy',
  'truck',
  'tv',
  'underline',
  'union',
  'upload',
  'user',
  'user-circle',
  'user-group',
  'user-minus',
  'user-plus',
  'users',
  'variable',
  'video',
  'video-camera',
  'video-camera-slash',
  'view-columns',
  'view-grid',
  'view-list',
  'viewfinder-circle',
  'wallet',
  'wifi',
  'window',
  'wrench',
  'wrench-screwdriver',
  'x-circle',
  'x-mark',
]
